module.exports = __webpack_public_path__ + "img/jobs_footer_logo.dccf1c40.svg";